import gql from "graphql-tag";

import {FetchPolicy} from "@khanacademy/wonder-blocks-data";
import {useQuery} from "@repo/data-gql";
import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {isDigitalSatStudent as IsDigitalSatStudentResponse} from "./__graphql-types__/isDigitalSatStudent.ts";

const IS_DIGITAL_SAT_STUDENT_QUERY: GqlOperation<IsDigitalSatStudentResponse> =
    gqlOp(gql`
        query isDigitalSatStudent {
            user {
                id
                mathProgress: curationItemProgress(
                    topicId: "x0fcc98a58ba3bea7"
                ) {
                    lastWorkedOn
                }
                readingAndWritingProgress: curationItemProgress(
                    topicId: "x0d47bcec73eb6c4b"
                ) {
                    lastWorkedOn
                }
            }
        }
    `);

export const exportedForTesting = {IS_DIGITAL_SAT_STUDENT_QUERY} as const;

export type IsSatStudentResult =
    | {
          status: "loading";
      }
    | {
          status: "success";
          value: boolean;
      }
    | {
          status: "error";
      };

export const useIsDigitalSatStudent = (): IsSatStudentResult => {
    const [result] = useQuery(IS_DIGITAL_SAT_STUDENT_QUERY, {
        fetchPolicy: FetchPolicy.NetworkOnly,
    });
    switch (result.status) {
        case "no-data":
        case "loading":
            return {status: "loading"};
        case "success":
            const hasWorkedOnMath =
                result.data.user?.mathProgress?.lastWorkedOn != null;
            const hasWorkedOnReadingAndWriting =
                result.data.user?.readingAndWritingProgress?.lastWorkedOn !=
                null;

            return {
                status: "success",
                value: hasWorkedOnMath || hasWorkedOnReadingAndWriting,
            };
        default:
            return {status: "error"};
    }
};
